import styled, { css } from "styled-components";
import { getThemeMedia, getThemeSpace } from "../helpers";
export const StepsContainer = styled.div `
	display: flex;
	justify-content: center;
	gap: ${getThemeSpace("8")};

	width: 100%;
`;
export const StepsItem = styled.div `
	display: flex;
	align-items: center;
	gap: ${getThemeSpace("8")};

	& > span {
		display: ${({ lenght, current: atual }) => (atual || lenght <= 2 ? "flex" : "none")};
		white-space: nowrap;
	}

	&::before {
		border-radius: 100%;
		background-color: var(--border-primary);

		min-width: 24px;
		max-width: 24px;
		min-height: 24px;
		max-height: 24px;

		color: var(--text-primary);
		text-align: center;
		content: attr(data-item);

		${({ current }) => current &&
    css `
				background-color: var(--surface-accent-light);
				color: var(--semantic-info-text);
			`}
		${({ completed }) => completed &&
    css `
				background-color: var(--surface-accent-dark);
				color: var(--text-invert);
			`}
	}

	&::after {
		background-color: var(--border-primary);

		width: 8px;
		height: 1px;

		content: '';
	}

	&:last-child {
		flex: 0;

		&::after {
			border: none;
			width: 0;
		}
	}

	button {
		cursor: default;
	}

	a {
		cursor: pointer;
	}

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			& > span {
				display: flex;
			}

			&::after {
				width: 16px;
			}
		}
	}
`;
//# sourceMappingURL=styles.js.map